import { createApp } from 'vue';
import App from './App.vue';

//Styles
import '@/assets/css/customization.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';

const app = createApp({
	extends: App,
	methods: {
		checkUser() {
			if(store.getters['auth/user']) store.dispatch('auth/me');
		},
		documentHeight() {
			document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
		}
	},
	async beforeMount() {
		window.addEventListener('resize', this.documentHeight);
		this.documentHeight();

		setInterval(this.checkUser, (5 * 60000));
		this.checkUser();
	}
});

//Vue Store
import store from '@/store';
app.use(store);

//Configuration
import { loadConfiguration } from '@/plugins/Configuration';
await loadConfiguration(app);

//Vue Router
import router from '@/router';
app.use(router);

//Traducciones
import i18n from '@/helpers/i18n/init.js';
app.use(i18n);

//Moment Js
import moment from 'moment';
import i18n_es from '@/helpers/i18n/translations/es.json';
moment.locale('es', i18n_es.moment);

//Vue Number Format
import VueNumberFormat from 'vue-number-format';
app.use(VueNumberFormat, {
	prefix: '',
	thounsand: '.',
	decimal: ','
});

//Vue Toast
import Toast from 'vue-toastification';
app.use(Toast, {
	position: 'top-center',
	transition: 'Vue-Toastification__fade',
	timeout: 3000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	showCloseButtonOnHover: false,
	closeButton: false,
	icon: false
});

//Focus directive
app.directive('focus', {
	mounted(el, active) {
		if(active.value == undefined || active.value == true) el.focus();
	}
});

//Tooltip directive
import { Tooltip } from 'bootstrap';
app.directive('tooltip', {
	mounted(el, binding) {
		if(binding.value != null) {
			el._tooltip = new Tooltip(el, {
				html: true,
				title: binding.value || '',
				placement: binding.arg || 'top',
				template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner text-start lh-sm"></div></div>'
			});

			el.style.cursor = 'help';
			el.style.userSelect = 'none';
		}else if(el._tooltip) el._tooltip.dispose();
	},
	updated(el, binding) {
		if(binding.value != null && el._tooltip) {
			el._tooltip.setContent({ '.tooltip-inner': binding.value || '' });
		}else if(el._tooltip) el._tooltip.dispose();
	},
	beforeUnmount(el) {
		if(el._tooltip) el._tooltip.dispose();
	}
});

//Placeholder directive
import assetsImgIconsFail from '@/assets/img/icons/fail.jpg';
app.directive('placeholder-image', {
	mounted(el) {
		let parent = el.parentNode;

		el.style.opacity = 0;
		el.classList.add('placeholder');
		if(parent) parent.classList.add('placeholder-glow');

		el.onload = () => {
			el.style.opacity = 1;
			el.classList.remove('placeholder');
			if(parent) parent.classList.remove('placeholder-glow');
		}

		el.onerror = () => {
			el.src = assetsImgIconsFail;
		}
	}
});

//Recarga el sitio cuando exista una nueva versión
if('serviceWorker' in navigator) navigator.serviceWorker.addEventListener('controllerchange', () => {
	window.location.reload();
});

app.mount('body');
